import { ShowFile2ModalForm } from "./ShowFile2ModalForm"


const ShowFile2ModalFormWrapper = () => {
    return (<ShowFile2ModalForm />)
}

export {ShowFile2ModalFormWrapper}